import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { Product } from '~app/modules/account/modules/buy-again/models';

export interface SelectItemBuyAgainApplicationEventPayload {
  product: Product
  priceType: PriceTypes
  productIndex: number,
  isBlackDealsEnabled: boolean,
}

export class SelectItemBuyAgainApplicationEventModel implements ApplicationEvent {
  type = ApplicationEventType.SelectItemBuyAgain;

  constructor(
    private product: Product,
    private priceType: PriceTypes,
    private productIndex: number,
    private isBlackDealsEnabled: boolean
  ) { }

  getPayload(): SelectItemBuyAgainApplicationEventPayload {
    return {
      product: this.product,
      priceType: this.priceType,
      productIndex: this.productIndex,
      isBlackDealsEnabled: this.isBlackDealsEnabled
    };
  }
}
